import React, { useEffect, useState } from "react";
import { getBookingHistory, logoutApi } from "../auth/authApi";

function ProfilePage() {


  const [bookingHistory , setBookingHistory] = useState();

 




  const handleLogOut = async () => {

    try {
      const response = await logoutApi();
      console.log(response);

      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");

      window.location.href = "/";
    } catch (error) {

      console.error("Logout failed try again", error);
    }

  };



const handlerBookingHistory = async()=>{
  try{
    const response = await getBookingHistory();
    setBookingHistory(response.data);
 
  }catch(error){
    
  console.log(error)
  }
}



console.log(bookingHistory);


useEffect(()=>{
  handlerBookingHistory();
},[])



  return (
    <div className="profile-page-bg">
      <div className="profile-page-main-container">
        <div className="profile-page-main-row">
          <div className="profile-pages-cols">
            <p className="profile-page-order-header"><b>Your Orders</b></p>
            <div className="profile-page-booking-history-cols">


                  {
                      bookingHistory?.map((e,i)=>(

                        <div className="profile-page-booking-history-row">
                          <p ><b>Order Details</b></p>
                          <p> ORDER_ID:  <span> {e.bookingId} </span></p>
                           <div>
                            <p style={{marginTop:"7px"}} > <b> Product Details: </b> <br/>

                              {
                                e?.items?.map((e,i)=>(
                                  <span>
                                    {e.name},  
                                    <b> Quantity: </b>{e.qty} ,

                                   {e?.varient &&  (<span> Variant : {e?.varient} </span>)  }  <br/>

                                   </span>
                                ))
                              }

                            </p>

                            
                            </div>


                          <div className="profile-page-order-details-row">
                            <div>
                              <div> <b>Contact Information</b></div>
                              <p>+91 {e?.mobileNumber}</p>
                               </div>
                            <div>
                              <p><b> Payment Method </b> </p>
                              <p>{e?.paymentMethod} - Rs.{e?.price?.totalPayable} </p>

                            </div>

                          </div>


                          
                          <div className="profile-page-order-details-row">
                            <div>
                              <div> <b> Shipping Address </b></div>

                              <p>{e?.shippingAddress?.address1},</p>
                              <p>{e?.shippingAddress?.address2}, {e?.shippingAddress?.pincode}-{e?.shippingAddress.city},  {e?.shippingAddress.state} </p>

                               </div>
                            <div> 
                              <div><b> Billing address </b></div>
                              <p> {e?.shippingAddress.firstName} {e?.shippingAddress.lastName}</p>
                              <p>{e?.shippingAddress?.address1},</p>
                              <p>{e?.shippingAddress?.address2}, {e?.shippingAddress?.pincode}-{e?.shippingAddress.city},  {e?.shippingAddress.state} </p>


                            </div>
                            

                          </div>

                              <div className="profile-page-order-details-row">
                            <div>
                              <div> Booking Status: {e?.bookingStatus} </div>
                              <div> <b> Order Date: {e?.createdAt} </b></div>
                            </div>
                            </div>


                        </div>

                      ))

                  }
            </div>


          </div>
          <div className="profile-pages-cols-right">
            <p className="profile-page-order-header"><b>Profile Details</b></p>
            <div className="profile-logout-btn">
             
              <button onClick={handleLogOut}>Logout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
